/*
 * @Description:
 * @Autor: SQX
 * @Date: 2026-05-29 15:26:30
 * @LastEditors: SQX
 * @LastEditTime: 2026-06-08 10:17:13
 */

/**
 * 解析条码数组，提取UID并添加解析状态
 * @param {Array} barcodeArray - 包含bar_code属性的对象数组
 * @returns {Array} 处理后的原数组（直接修改原数组对象）
 */
export function parseBarcodeUDI(barcodeArray) {
    // 检查输入是否为数组
    if (!Array.isArray(barcodeArray)) {
        console.error('输入参数必须是数组');
        return [];
    }

    barcodeArray.forEach(item => {
        // 初始化解析状态为失败
        item.parse_status = 2;
        item.bar_code_udi = ''; // 清除可能存在的旧UDI

        // 检查bar_code是否存在且为非空字符串
        if (typeof item.bar_code !== 'string' || item.bar_code.trim() === '') {
            return; // 空值或非字符串，保持失败状态
        }

        const barcode = item.bar_code.trim();

        // 检查是否以01开头且长度足够
        if (barcode.startsWith('01') && barcode.length >= 16) {
            // 截取01后面的14位作为UDI
            item.bar_code_udi = barcode.substring(2, 16);
            item.parse_status = 1;
        }
    });

    return barcodeArray;
}



export function getRawType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1);
}

/**
 * 2. 定义类型枚举 (Enum)
 * 这里列出了常见的 JavaScript 数据类型
 */
export const DataType = {
    STRING: 'String',
    NUMBER: 'Number',
    BOOLEAN: 'Boolean',
    NULL: 'Null',
    UNDEFINED: 'Undefined',
    SYMBOL: 'Symbol',
    BIGINT: 'BigInt',

    OBJECT: 'Object',
    ARRAY: 'Array',
    FUNCTION: 'Function',
    DATE: 'Date',
    REGEXP: 'RegExp',
    ERROR: 'Error',
    MAP: 'Map',
    SET: 'Set',
    PROMISE: 'Promise',
    // 可以根据需要添加更多类型，如 WeakMap, WeakSet 等
};

/**
 * 3. 类型判断方法
 * @param {*} obj - 需要判断的对象
 * @param {string} expectedType - 期望的类型，传入 DataType 枚举中的值
 * @returns {boolean} - 如果类型匹配返回 true，否则返回 false
 */
export function isType(obj, expectedType) {
    // 获取实际类型
    const actualType = getRawType(obj);
    // 比较实际类型与期望类型
    return actualType === expectedType;
}

//清洗特使格式json数据方法
// "[{'identifier': '17'...}]" 这中不能直接解析的json数组数据
export function parseLenientJson(str) {
    if (typeof str !== 'string') {
        return str;
    }

    let content = str;

    // 1. 去除外层包裹的引号
    // 检查是否以 " 或 ' 开头，并以对应的引号结尾
    if ((content.startsWith('"') && content.endsWith('"')) ||
        (content.startsWith("'") && content.endsWith("'"))) {
        // 去掉首尾各一个字符
        content = content.slice(1, -1);
    }

    // 2. 将单引号替换为双引号
    // 注意：简单替换可能在值包含转义单引号时出错，但对于常规配置数据通常有效
    content = content.replace(/'/g, '"');

    // 3. 解析标准 JSON
    try {
        return JSON.parse(content);
    } catch (e) {
        console.error("JSON 解析失败:", e);
        return null;
    }
}
